import { Input } from 'antd';
import { FilterBar, Button, FormItem, } from 'asumsi-components';
import React from 'react';
import { Link } from 'react-router-dom';

const Search = Input.Search;
export default function (props: any) {
  const { onSearch } = props;

  return (
    <FilterBar>
      <FormItem>
        <Search onSearch={onSearch} allowClear={false} placeholder="Masukan kata kunci..." />
      </FormItem>
      <FormItem className="asumsi-filter-bar__right">
        <Link to="users/form">
          <Button className="float-right" type="primary" iconLeft="plus" size="medium" text="Tambah" />
        </Link>
      </FormItem>
    </FilterBar>
  );
}



// WEBPACK FOOTER //
// ./src/pages/users/libraries/filter.tsx